import { create } from 'zustand';

import {
  MOBILE_DEVICE_MAX_WIDTH,
  ONBOARDING_BORDER_MAX_WIDTH,
} from '../utils/constants';

interface IViewportStore {
  isMobile: boolean;
  isDesktop: boolean;
  isOnboardingMobile: boolean;
  setViewport: (width: number) => void;
}

export const useViewportStore = create<IViewportStore>((set) => ({
  isMobile: false,
  isDesktop: false,
  isLgDesktop: false,
  isOnboardingMobile: false,
  setViewport: (width) => {
    set({
      isMobile: width < MOBILE_DEVICE_MAX_WIDTH,
      isDesktop: width >= MOBILE_DEVICE_MAX_WIDTH,
      isOnboardingMobile: width < ONBOARDING_BORDER_MAX_WIDTH,
    });
  },
}));
